import ImportContactsIcon from '@material-ui/icons/ImportContacts';
import * as React from 'react';
export default {
  ImportContactsIcon,
  React
};